import React, { useState, FormEvent, useEffect, useMemo } from 'react'
import { connect, useDispatch } from 'react-redux'
import { entitySmallTextField } from '../../Utils/EntityField'
import { AppState } from '../../../reducers/index'
import { PreorderDetailDataState } from '../../../reducers/preorder/preorderDetailData'
import { upsertPreorderDetail } from '../../../actions/preorder/preorderDetailUpsert'
import { PreorderDetailInput } from '../../../models/PreorderDetail'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { PersonDetailState } from '../../../reducers/person/personDetail'
import { SessionState } from '../../../reducers/auth/session'
import { IconProgressButton } from '../../Utils/ProgressButton'
import { CheckCircleOutlined, NotInterestedOutlined } from '@mui/icons-material';
import { Stack, Tooltip, Typography } from '@mui/material'
import { formattedCurrency } from '../../../utils/StringUtils'
import { GenericModalDialog } from '../../modalDialog/GenericModalDialog'
import { fetchPreorderDetails } from '../../../actions/preorder/preorderDetail'
import { PreorderDetailListState } from '../../../reducers/preorder/preorderDetailList'

interface StateProps {
  preorderDetail: PreorderDetailDataState
  session: SessionState
  person: PersonDetailState
}

interface Props {
  detail: PreorderDetailInput
  editing: boolean
  disable?: boolean
  preorder?: PreorderDetailListState
  getPreorder?: () => number;
  setPreorder: () => void;
  getBalancePrepayment?: (withSurplus: boolean) => number;
}

const empty: PreorderDetailInput = {
  id: null,
  preorderId: 0,
  productId: 0,
  code: '',
  qty: 0,
  package: 0,
  priceListId: 0,
  listPrice: 0,
  money: '',
  price: 0,
  discount1: 0,
  discount2: 0,
  discount3: 0,
  discount4: 0,
  discount5: 0,
  discount6: 0,
  discount7: 0,
  discount8: 0,
  discount9: 0,
  discount10: 0
}

const PreorderDetailUpsert: React.FC<StateProps & Props> = ({ preorder, preorderDetail, detail, disable, editing, getPreorder, setPreorder, getBalancePrepayment }) => {
  const [changed, setChanged] = useState<boolean>(false)
  const [disableButton, setDisableButton] = useState<boolean>(false)
  const [preorderDetailInfo, setPreorderDetailInfo] = useState<PreorderDetailInput>(detail || preorderDetail.preorderDetail || empty)
  const [alert, setAlert] = useState<boolean>(false)
  const { t } = useTranslation('preorder')
  const dispatch = useDispatch()
  const params = useParams<{ preorderDetailId: string }>()

  const change = (newPreorderDetailInfo: PreorderDetailInput) => {
    setPreorderDetailInfo(newPreorderDetailInfo)
    setChanged(!errorQty(newPreorderDetailInfo) && (Number(newPreorderDetailInfo.qty) !== 0))
  }

  const getExists = (code: string) => {
    if (code &&
      preorder &&
      preorder.preorderDetail &&
      preorder.preorderDetail.length > 0) {
      return preorder.preorderDetail.find(d => d.code === code)
    }
    return undefined
  }

  const addOrUpdatePreorderDetail = async () => {
    console.log('preorderdetailinfo.preorderid', preorderDetailInfo.preorderId)
    console.log('detail.preorderid', detail.preorderId)
    if (!disable) {
      const detailInfo = preorderDetailInfo
      if (detailInfo && detailInfo.qty && (Number(detailInfo.qty) !== 0)) {

        const exists = getExists(detailInfo.code!);
        if (exists !== undefined && exists !== null) {
          console.log('existe ', exists)
          console.log('detailInfo.qty ', detailInfo.qty)
          console.log('previouwqty ', previousQty())
          detailInfo.id = exists.id;
          detailInfo.qty = Number(exists.qty) + Number(detailInfo.qty) - Number(previousQty());
        }
        else {
          if (detailInfo.id) {
            detailInfo.id = null
          }
          console.log('paso por el else ', detailInfo)
        }
        const preorderId = detail.preorderId || (getPreorder && getPreorder())
        console.log('addorupdate')
        await dispatch(upsertPreorderDetail({ ...detailInfo, preorderId: preorderId }, () =>
          detail.preorderId && dispatch(fetchPreorderDetails(detail.preorderId?.toString(), undefined, '?limit=1000'))
        ))
      }
    }
    setPreorder && setPreorder()
    setChanged(false)
  }

  const clearDetailInfo = async () => {
    setAlert(false)
    if (!editing)
      setPreorderDetailInfo({ ...preorderDetailInfo, qty: 0 })
    else
      setPreorderDetailInfo({ ...preorderDetailInfo, qty: detail && detail.qty })
    setChanged(false)
  }

  const previousInfo = () => detail && detail.price ? (detail.price * detail.qty!) : 0
  const previousQty = () => detail && detail.qty ? detail.qty : 0

  //const previousQty = () => { const exist = detail && detail.code ? getExists(detail.code) : null; return exist ? exist.qty : 0 }
  //const previousInfo = () => { const exist = detail && detail.code ? getExists(detail.code) : null; return exist ? (exist.price * exist.qty!) : 0 }


  const cumulative = () => preorder && preorder.preorderDetail ? preorder.preorderDetail.reduce((amount, det) => amount + Number(det.qty * det.price), 0) : 0

  const controlPrepaymentIfExists = () => {
    console.log('dato', getBalancePrepayment ? getBalancePrepayment(true) - cumulative() : -1)
    console.log('cumulative ', cumulative())
    console.log('con y sin ', getBalancePrepayment ? getBalancePrepayment(true) : -1, getBalancePrepayment ? getBalancePrepayment(false) : -1)
    /*
    309463.1368702236 245447.49587022362

    dato -59031.96712977643
    cumulative  304479.46300000005
    con y sin  245447.49587022362 245447.49587022362
    
    preorderdetail (3) [{…}, {…}, {…}]
    ctrl -59031.96712977643
    */
    console.log('preorder', preorder)
    console.log('preorderdetail', preorder ? preorder.preorderDetail : 'preorder NO EXITE')
    if (preorderDetailInfo && preorderDetailInfo.qty) {
      const ctrl = getBalancePrepayment ? getBalancePrepayment(true) - cumulative() : -1
      console.log( 'ctrl', ctrl)
      if (ctrl >= 0 && (ctrl) < ((preorderDetailInfo.price! * preorderDetailInfo.qty) - (previousInfo()))) {
        return false
      }
    }
    return true
  }


  const changePreorderDetail = async (event: FormEvent) => {
    setDisableButton(true)
    event.preventDefault()
    if (!disable) {
      /*
    if (preorderDetailInfo && preorderDetailInfo.qty) {
      if( preorderDetailInfo.preorderId )
         dispatch(fetchPreorderDetails(preorderDetailInfo.preorderId?.toString(), undefined, '?limit=1000'))//,'','&all=true'))
      */
      /*
      console.log('dato', getBalancePrepayment ? getBalancePrepayment(true) - cumulative() : -1)
      console.log('dato2 ', getBalancePrepayment ? getBalancePrepayment(true) : -1, cumulative())
      console.log('preorder', preorder)
      console.log('preorderdetail', preorder ? preorder.preorderDetail : 'preorder NO EXITE')
      const ctrl = getBalancePrepayment ? getBalancePrepayment(true) - cumulative() : -1
      if (ctrl >= 0 && (ctrl) < ((preorderDetailInfo.price! * preorderDetailInfo.qty) - (previousInfo()))) {
      */
      if (!controlPrepaymentIfExists()) {
        setDisableButton(false)
        setAlert(true)
      }
      else {
        try {
          await addOrUpdatePreorderDetail()
          await clearDetailInfo()
          setDisableButton(false)
        }
        catch {
          setDisableButton(false)
        }
      }
    }
    else {
      setDisableButton(false)
    }
  }

  const errorQty = (dato: PreorderDetailInput) => {
    if (dato.package && dato.qty)
      if ((dato.qty % dato.package) !== 0)
        return true
    return false
  }

  /*
    useEffect(() => {
      if (changed && detail.preorderId) {
        dispatch(fetchPreorderDetails(detail.preorderId?.toString(), undefined, '?limit=1000'))//,'','&all=true'))
      }
      // eslint-disable-next-line
    }, [changed])//, dispatch, detail.preorderId])
  */

  useEffect(() => {
    if (preorderDetail.preorderDetail) {
      setPreorderDetailInfo(params.preorderDetailId ? preorderDetail.preorderDetail : empty)
    }
  }, [preorderDetail.preorderDetail, params.preorderDetailId])

  // eslint-disable-next-line
  const PreorderDetailInfoField = useMemo(() => entitySmallTextField(change), [])

  return (
    <>
      <GenericModalDialog
        dialogProps={{ open: alert }}
        isOpen={alert}
        onCancel={() => clearDetailInfo()} title={t('warning')}>
        <Stack display="flex" textAlign="center">
          <Typography variant="subtitle1">{`${t('messageWarning1')} ${formattedCurrency((preorderDetailInfo.price! * preorderDetailInfo.qty!) - (previousInfo()))} `}</Typography>
          <Typography variant="subtitle1">{`${t('messageWarning2')} ${formattedCurrency(getBalancePrepayment ? getBalancePrepayment(true) - cumulative() : 0)} `}</Typography>
          <Typography variant="h6">{t('messageWarning3')}</Typography>
        </Stack>
      </GenericModalDialog>

      <form onSubmit={changePreorderDetail}>
        <Stack display="flex" flexDirection='column' justifyContent="center" alignItems="center">
          <Stack display="flex" flexDirection='row' justifyContent="center" alignItems="center">
            <PreorderDetailInfoField
              key="qty"
              label={''}
              entity={preorderDetailInfo}
              attr="qty"
              error={errorQty(preorderDetailInfo)}
              id="outlined-error"
              inputProps={{
                disabled: disable ? disable : false,
                type: "number", min: 0,// preorderDetailInfo.package ?? 1, 
                step: preorderDetailInfo.package ?? 1,
                style: {
                  textAlign: 'center',
                  paddingTop: editing ? "0px" : "8.5px",
                  paddingBottom: editing ? "0px" : "8.5px",
                  lineHeight: editing ? "0.5rem" : "1.4375em",
                }
              }}
              style={{
                paddingLeft: "5px",
                maxWidth: '110px'
              }}
            />
            <IconProgressButton state={preorderDetail} disabled={!changed || disableButton}>
              <Tooltip title={editing ? !disable ? t('modify') : t('unableOnPrepayment') : !disable ? t('create') : t('unableOnPrepayment')}>
                {!disable ? <CheckCircleOutlined /> : <NotInterestedOutlined sx={{ color: 'red' }} />}
              </Tooltip>
            </IconProgressButton>
          </Stack>
          <Typography variant='caption' color="error">{errorQty(preorderDetailInfo) ? `Debe ser multiplo de ${preorderDetailInfo.package}` : ''}</Typography>
        </Stack>
      </form >
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  preorderDetail: state.preorderDetailData,
  preorder: state.preorderDetailList,
  session: state.session,
  person: state.personDetail
})

export default connect<StateProps, {}, Props, AppState>(mapStateToProps, {})(PreorderDetailUpsert)
